import styled from 'styled-components';
import { CUSTOM_TYPOGRAPHY_CSS, type CustomTypographyProps } from './custom-typography';

export const P20 = styled.p<CustomTypographyProps>`
  font-size: 20px;
  line-height: 1.5;

  ${CUSTOM_TYPOGRAPHY_CSS};
`;
